import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';

const { useQuery, createKey } = createQueryData({
  endPoint: 'Acceptance/address/{id}/attachments',
  options: {
    createParams: ({ endPoint, params }) => {
      const { addressId } = params;
      return { url: endPoint.replace('{id}', addressId) };
    },
  },
});

const useRoomAttachmentsQuery = ({
  params: { addressId } = {},
  options,
} = {}) =>
  useQuery({
    params: { addressId },
    options: { enabled: Boolean(addressId), staleTime: 1000, ...options },
  });

const useInvalidateRoomAttachments = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ addressId }) => {
      queryClient.invalidateQueries(createKey({ addressId }));
    },
    [queryClient]
  );
};

export { useRoomAttachmentsQuery, useInvalidateRoomAttachments };
